module.exports = __webpack_public_path__ + "static/media/skull-new-21.c0ed108d.png";